/**
 * This class is to write utility methods over date
 */
export class DateUtil{
    static monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
    static getFullDate(seconds) {
        if (seconds) {
          const date = new Date(seconds);
          return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() + ', ' +
            ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
            + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
        } else {
          return 'not present';
        }
      }
    
     static getNewTypeDate(datestring) {
        if (datestring) {
          if (typeof datestring === 'string') {
            const dt = new Date(datestring.replace('+0000', 'Z'));
            return DateUtil.getFullDate(Math.round(dt.getTime()));
          } else {
            console.log('full date='+datestring)
            return DateUtil.getFullDate(datestring);
          }
        } else {
          return 'not present';
        }
      }
    
      static getDateWithoutTime(seconds) {
        if (seconds) {
          const date = new Date(seconds);
          return '' + DateUtil.monthNames[date.getMonth()]+ ' ' + date.getDate() + ', ' + ' ' + date.getFullYear();
        } else {
          return 'not present';
        }
      }
    
     static  getDate(datestring) {
        if (datestring) {
          if (typeof datestring === 'string') {
            const dt = new Date(datestring.replace('+0000', 'Z'));
            return DateUtil.getDateWithoutTime(Math.round(dt.getTime()));
          } else {
            return DateUtil.getDateWithoutTime(datestring);
          }
        } else {
          return '';
        }
      }
}